<script>
  export let label;
  export let group = undefined;
  export let value = undefined;
  export let changeFn = () => {};
</script>

<label class="check-container"
  >{label}
  <input type="radio" bind:group {value} on:change={changeFn} />
  <span class="checkmark" />
  <slot />
</label>

<style>
  .check-container {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
  }

  /* Hide the browser's default checkbox */
  .check-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border: 1px solid #000;
  }

  .check-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  .check-container input:checked ~ .checkmark {
    background-color: #fe5900;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .check-container input:checked ~ .checkmark:after {
    display: block;
  }

  .check-container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
